import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import PropTypes from 'prop-types'

import Arrow from 'lib/icons/arrow'
import { removeLanguageUrlFromPath } from 'lib/utils/links'
import I18n from 'lib/i18n'

const isElementActive = (element, pathname) => removeLanguageUrlFromPath(decodeURI(pathname)) === element.link

const BoostTag = () => <span className='boost-tag'>{I18n.t('courses.boost.boost_class_button')}</span>

const MenuElement = ({
  coursesCount,
  menuItem,
  pathname,
  isExpanded,
  expandedMenuItem,
  handleMenuElementClick,
  methodProps,
  isButton
}) => {
  const classNamesParts = [
    isButton && 'button',
    isElementActive(menuItem, pathname) && !isExpanded && (isButton ? 'button active' : 'active')
  ].filter(Boolean)
  const classNameExist = classNamesParts.length !== 0

  return (
    <>
      <li className={classNameExist ? classNamesParts.join(' ') : null}>
        <a
          onClick={event => handleMenuElementClick(menuItem, expandedMenuItem, event)}
          href={menuItem.link}
          {...methodProps}
        >
          <div className='menu-item-wrapper'>
            <span>{ReactHtmlParser(menuItem.title)}</span>
            {coursesCount > 0 && menuItem.name === 'courses' && <BoostTag />}
          </div>
          {menuItem.children && (
            <Arrow isMenu stroke='#24292e' dir={menuItem.name === expandedMenuItem ? 'top' : 'down'} />
          )}
        </a>
      </li>
      {menuItem.children &&
        menuItem.name === expandedMenuItem &&
        menuItem.children.map((childElement, subIndex) => (
          <li
            className={`pl-20${isElementActive(childElement, pathname) ? ' active' : ''}`}
            key={`menu_sub_item_${subIndex}`}
          >
            <a
              href={childElement.link}
              className={`child-element-content${menuItem.isAdmin ? ' admin-menu-element ' : ''}`}
            >
              <span>{ReactHtmlParser(childElement.title)}</span>
            </a>
          </li>
        ))}
    </>
  )
}

MenuElement.propTypes = {
  coursesCount: PropTypes.number,
  menuItem: PropTypes.object,
  pathname: PropTypes.string,
  isExpanded: PropTypes.bool,
  expandedMenuItem: PropTypes.string,
  handleMenuElementClick: PropTypes.func,
  methodProps: PropTypes.object,
  isButton: PropTypes.bool
}

export default MenuElement
